export default {
    date_of_birth: 'Date of birth:',
    insurance: 'Insurance',
    group: 'Group # ',
    id: 'ID',
    primary_care: 'Primary Care',
    clinical_history: 'CLINICAL HISTORY',
    attachments: 'Attachments:',
    note: 'NOTE',
}
